import { PREFIX_COVERHOLDER } from "@/api/Model/ProductOwnerModel";
import AbstractRearJacket from "../RearJacket";

class RearJacket extends AbstractRearJacket {
  static getResourceEndpoint() {
    return PREFIX_COVERHOLDER + '/product-rear-jackets-ipr';
  }
}

export default RearJacket;
